import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=8fd6b8ba&"
import script from "./ProductMain.vue?vue&type=script&lang=ts&"
export * from "./ProductMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports